import * as v from 'valibot'

export const EventSchema = v.object({
	description: v.optional(v.string()),
	starts_at: v.pipe(v.string(), v.minLength(1, 'Start time is required')),
	duration_mins: v.optional(v.number(), 60),
	rrule: v.optional(v.string()),
	meeting_url: v.optional(v.pipe(v.string(), v.url('Must be a valid URL'))),
	group: v.nullable(v.string()),
})

export type EventForm = v.InferInput<typeof EventSchema>
